import { useServerSdk } from "../../RootNavigator/services/ServerSdk";
import { useAssistance } from "../../RootNavigator/services/Assistance";
import ProjectTabCommunication from "./tabs/ProjectTabCommunication";
import ProjectTabCompliances from "./tabs/ProjectTabCompliances";
import ProjectTabDescription from "./tabs/ProjectTabDescription";
import ProjectTabFiles from "./tabs/ProjectTabFiles";
import ProjectTabFunding from "./tabs/ProjectTabFunding";
import ProjectTabInvestigation from "./ProjectTabInvestigation";
import ProjectTabMain from "./tabs/ProjectTabMain";
import ProjectTabProducts from "./tabs/ProjectTabProducts";
import ProjectTabSalaries from "./tabs/ProjectTabSalaries";
import ProjectTabServices from "./tabs/ProjectTabServices";
import ProjectTabTransfer from "./tabs/ProjectTabTransfer";
import ProjectDisplay from "./tabs/ProjectDisplay";
import ProjectTabIndicators from "./tabs/ProjectTabIndicators";
import { getProjectLabel } from "@hpo/client/utilities/helpers/ProjectHelper";
import Tabs, { Tab } from "@hpo/client/utilities/Tabs";
import Spacer from "@hpo/client/utilities/Spacer";
import PageHeader from "@hpo/client/utilities/PageHeader";
import Page from "@hpo/client/utilities/Page";
import { ProjectInstructor } from "@hpo/client/models/Project";
import { projectRoute } from "@hpo/client/utilities/routes";
import useRouteParam from "@hpo/client/utilities/Routing/useRouteParam";
import { Tag } from "@hpo/client/models/Tag";
import ProjectStatusBadge from "@hpo/client/utilities/ProjectStatusBadge";

export default function ProjectScreen() {
  const server = useServerSdk();
  const id = useRouteParam(projectRoute, "id");

  const project = server.suspender.use(server.getProject(id));
  const tags = server.suspender.use(server.getTags());

  const onReload = () => {
    server.suspender.refresh(server.getProject(id));
  };

  return <ProjectView project={project} onReload={onReload} tags={tags} />;
}

type RequestViewProps = {
  project: ProjectInstructor;
  tags: Array<Tag>;
  onReload: () => unknown;
};

function ProjectView(props: RequestViewProps) {
  const { project } = props;

  const assistance = useAssistance();
  assistance.useChatWith([project.organization]);
  assistance.useVisibilityDecision(true);

  const annexesTabs = project.annexes.map((a) => {
    if (a.type === "a2_salary") {
      return (
        <Tab id="a2_salary" title="A2 - Récap salaires" key={a.type}>
          <ProjectTabSalaries {...props} annex={a} />
        </Tab>
      );
    } else if (a.type === "a2_product") {
      return (
        <Tab id="a2_product" title="A2 - Récap devis (produits)" key={a.type}>
          <ProjectTabProducts {...props} annex={a} />
        </Tab>
      );
    } else if (a.type === "a2_service") {
      return (
        <Tab id="a2_service" title="A2 - Récap devis (services)" key={a.type}>
          <ProjectTabServices {...props} annex={a} />
        </Tab>
      );
    } else if (a.type === "a3") {
      return (
        <Tab id="a3" title="A3 - Plan de financement" key={a.type}>
          <ProjectTabFunding {...props} annex={a} />
        </Tab>
      );
    } else if (a.type === "a4") {
      return (
        <Tab id="a4" title="A4 - Plan de comm" key={a.type}>
          <ProjectTabCommunication {...props} annex={a} />
        </Tab>
      );
    } else if (a.type === "a5") {
      return (
        <Tab id="a5" title="A5 - Plan de transfert" key={a.type}>
          <ProjectTabTransfer {...props} annex={a} />
        </Tab>
      );
    }
  }, []);

  return (
    <Page>
      <PageHeader
        title={getProjectLabel(props.project)}
        subtitle={props.project.organization.businessName}
        right={<ProjectStatusBadge status={project.status} />}
      />
      <Spacer />
      <Tabs>
        <Tab id="identification" title="Demande">
          <ProjectTabMain {...props} />
        </Tab>
        <Tab id="compliances" title="Elligibilité">
          <ProjectTabCompliances {...props} />
        </Tab>
        <Tab id="files" title="Pièces jointes">
          <ProjectTabFiles {...props} />
        </Tab>
        <Tab id="a1-description" title="A1 - Description">
          <ProjectTabDescription {...props} />
        </Tab>
        <Tab id="a1-indicators" title="A1 - Indicateurs">
          <ProjectTabIndicators {...props} />
        </Tab>
        {annexesTabs}
        <Tab id="instruction" title="Instruction">
          <ProjectTabInvestigation {...props} />
        </Tab>
        <Tab id="display" title="Affichage">
          <ProjectDisplay project={project} onReload={props.onReload} />
        </Tab>
      </Tabs>
    </Page>
  );
}
